import * as React from 'react';
import { CheckboxField } from '@cian/components';

const style = require('./checkbox_list_item.css');

export interface ICheckboxListProps {
  isSelected: boolean;
  select(value: number): () => void;
  deselect(value: number): () => void;
  text: string;
  value: number;
}

export const CheckboxListItem: React.StatelessComponent<ICheckboxListProps> = props => {
  const { isSelected, text, value, deselect, select } = props;
  const handler = isSelected ? deselect : select;

  return (
    <div className={style['checkboxDiv']}>
      <CheckboxField label={text} value={isSelected} onValueChange={handler(value)} />
    </div>
  );
};
